/**
 * Severity vocabulary for verse analysis ratings — the skjv-mobile
 * presentation: score 3/2/1 → Major/Subtil/Minor Problem with the
 * mobile brand colors (via .analysis-severity-N CSS custom props).
 */

import type { ComponentType } from 'react';
import { PROBLEM_LABELS } from '@skjv/common';
import { AlertCircleIcon, HelpCircleIcon, InfoIcon } from '@components/icons';

export interface SeverityPresentation {
  title: string;
  Icon: ComponentType<{ className?: string; filled?: boolean }>;
  className: string;
}

const SEVERITY: Record<1 | 2 | 3, SeverityPresentation> = {
  3: { title: PROBLEM_LABELS[3], Icon: AlertCircleIcon, className: 'analysis-severity-3' },
  2: { title: PROBLEM_LABELS[2], Icon: HelpCircleIcon, className: 'analysis-severity-2' },
  1: { title: PROBLEM_LABELS[1], Icon: InfoIcon, className: 'analysis-severity-1' },
};

/** Clamp arbitrary scores into the 1-3 presentation range */
export function severityFor(score: number): SeverityPresentation {
  const clamped = Math.min(3, Math.max(1, Math.round(score))) as 1 | 2 | 3;
  return SEVERITY[clamped];
}
